import {html, LitElement} from '../lib/lit-html.js';

// The following link shows a better way of handling form web components but
// browser support is currently sketchy (2021-08-11).
// https://html.spec.whatwg.org/multipage/custom-elements.html#custom-elements-face-example

export class EkmSearchCategories extends LitElement {
	static get properties(){
		return {
			options: {type: Array},
			value: {type: String}
		}
	}

	constructor(){
		super();
		this.options = [];
		this.value = '';
	}

	render(){
		if (this.options.length === 0){
			this.style.display = 'none';
			return html ``;
		}

		this.style.display = '';

		return html`
			<select name="tlc" @change=${this._onchange}>
				<option value="" ?selected=${this.value === ''}>All</option>
				${this.options.map(
					o => html`<option value=${o} ?selected=${this.value === o}>${o}</option>`
				)}
			</select>
		`;
	}

	createRenderRoot(){
		return this;
	}

	_onchange(event){
		this.value = event.target.value;
		this.dispatchEvent(new CustomEvent('search-category-change', {
			bubbles: true,
			detail: {
				value: this.value
			}
		}));
	}
}

customElements.define('ekm-search-categories', EkmSearchCategories);
